<template>
  <div
    id="work_manage"
    v-loading.fullscreen.lock="isLoading"
    element-loading-text="しばらくお待ち下さい..."
    customClass="loading"
  >
    <!-- ログイン後 -->
    <div class="h-100" :class="{'blue-back':isBlueBack}" v-if="isNoHeader && !isManager">
      <!-- サイドメニュー -->
      <SideMenu :systemVersion="SYSTEM_VERSION"></SideMenu>
      <div>
        <HeaderMene></HeaderMene>
        <div class="flex-grow-1 overflow-auto">
          <router-view />
        </div>
        <BottomMene></BottomMene>
      </div>
    </div>
    <div class="h-100" v-else-if="isNoHeader && isManager">
      <SideBar :systemVersion="SYSTEM_VERSION"></SideBar>
    </div>
    <!-- ログイン前 -->
    <div v-else class="h-100">
      <router-view />
      <div class="text-muted text-center mt-2 system-version">{{ SYSTEM_VERSION }}</div>
    </div>
    <!--  -->
    <AlertModalVue
      ref="AlertModalServerError"
      @handleOk="handleOkServerError()"
      :message="SERVER_ERROR_MSG"
      title="サーバ通信エラー"
    ></AlertModalVue>
    <AlertModalVue
      ref="AlertModalAuthError"
      @handleOk="handleOkAuthError()"
      :message="AUTH_ERROR_MSG"
      title="認証エラー"
    ></AlertModalVue>
  </div>
</template>

<script>
import config from "./const/config";
import Util from "./mixin/utility";
import SideMenu from "./components/BaseLayout/SideMenu";
import SideBar from "./views/manager/SideBar.vue";
import AlertModalVue from "./components/Parts/AlertModal.vue";
import BottomMene from "./components/BaseLayout/BottomMene.vue";
import HeaderMene from "./components/BaseLayout/HeaderMene.vue";
export default {
  mixins: [Util],
  name: "App",
  components: { BottomMene, HeaderMene, SideMenu, AlertModalVue, SideBar },
  data() {
    return {
      deadlineApproaching: false,

      SYSTEM_VERSION: "V.1.5.9",
      AUTH_ERROR_MSG: "ユーザー情報が確認できませんでした。\r\n再度ログインしてください。",
      SERVER_ERROR_MSG: "サーバー通信中にエラーが発生しました。\r\nしばらく待って再度実行してください",
    };
  },
  mounted: function () {
    document.title = "勤怠管理";
    this.$store.dispatch(config.STORE.INDEX.ACTION.authErrorModalHide);
    this.$store.dispatch(config.STORE.INDEX.ACTION.serverErrorModalHide);
  },
  computed: {
    // ヘッダーを表示しないページかを判定
    isNoHeader() {
      let re = false;
      if (
        this.$route.path != "/" &&
        this.$route.path != "/manager" &&
        this.$route.path != "/manager/"
      ) {
        re = true;
      } else {
        re = false;
      }
      return re;
    },
    // 管理者用のサイドメニューを使用するかどうか
    isManager(){
      let managerIndex =  this.$route.path.indexOf('/manager');
      console.log("this.$route.path:"+ this.$route.path);
      console.log("managerIndex:"+ managerIndex);
      return managerIndex > -1;
    },
    // 背景が青色か
    isBlueBack() {
      let blueIndex =  this.$route.path.indexOf('/AttendanceCheck');
      return blueIndex > -1;
    },
    // Vuexに定義したStateを、利用できるようにする
    isLoading() {
      return this.$store.state.isLoading;
    },
    authErrorModalShow() {
      return this.$store.getters.getAuthErrorModalShow;
    },
    serverErrorModalShow() {
      return this.$store.getters.getServerErrorModalShow;
    },
    loggedIn() {
      return this.$store.state.userInfo.loggedIn;
    },
    loginContractorName: function () {
      return this.$store.getters.getContractorName;
    },
    selectCorpName: function () {
      return this.$store.getters.getCorpName;
    },
  },
  watch: {
    authErrorModalShow(val) {
      if (val) {
        this.$refs.AlertModalAuthError.openModal();
      }
    },
    serverErrorModalShow(val) {
      if (val) {
        this.$refs.AlertModalServerError.openModal();
      }
    },
  },
  methods: {
    handleOkServerError: function () {
      this.$store.dispatch(config.STORE.INDEX.ACTION.serverErrorModalHide);
    },
    handleOkAuthError: function () {
      this.$store.dispatch(config.STORE.INDEX.ACTION.authErrorModalHide);
    },
  },
};
</script>
<style>

.blue-back{
    background: rgb(224 239 255);
}

.system-version {
  font-size: 13px;
  position: absolute;
  bottom: 1.5em;
  width: 100%;
}
</style>
